<template>
  <div id="contents" class="service-intro">
    <div class="inner">
      <h3 class="main-title">서비스소개</h3>
      <ul class="tab-wrap">
        <li><a href="/service/hometown" class="tab-btn">SKB 우리동네광고</a></li>
        <li><a href="/service/skylife" class="tab-btn">KT스카이라이프 IPTV광고</a></li>
        <li><a href="/service/experience" class="tab-btn active">체험단 마케팅</a></li>
        <li><a href="/service/reporter" class="tab-btn">기자단 마케팅</a></li>
        <li><a href="/service/insta" class="tab-btn">인스타 마케팅</a></li>
        <li><a href="/service/viral" class="tab-btn">바이럴 마케팅</a></li>
      </ul>
    </div>
    <div class="service-intro-wrap intro03">
      <section class="sec01">
        <div class="inner flexbox center">
          <div class="title-wrap">
            <h4 class="section-title">업종 맞춤형 전문 인플루언서를 <br/>통한 콘텐츠 노출</h4>
            <p class="section-desc">업종별 특징에 맞는 전문성 있는 인플루언서와 함께 신규 고객의 니즈를 충족하여 콘텐츠 홍보 </p>
          </div>
        </div>
      </section>
      <section class="sec02">
        <div class="inner">
          <ul class="list type-row">
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro10.png" alt=""/>
                  <h3 class="title">SNS 체험단 마케팅</h3>
                  <p class="desc">인맥부터 정보공유까지 다양한 스타일로 광고가
                    가능하여, 트렌디한 마케팅으로 연령층을 불문하고 사랑받고 있는 소통적 마케팅 전략입니다.</p>
                </span>
            </li>
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro11.png" alt=""/>
                  <h3 class="title">인스타그램 체험단</h3>
                  <p class="desc">일상을 담은 듯 자연스러운 스토리를 통해 브랜드를 인지시키며, 국내 이용자의 팔로워를 증가시키고
                    이벤트, 프로모션 콘텐츠의 자연스러운 참여를 유도하며 인기 게시물 노출 및 해시태그 분석을 통해
                    인기 해시태그와 업종 관련 키워드로 더 많은 잠재고객에게 노출을 확산합니다.</p>
                  </span>
            </li>
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro12.png" alt=""/>
                  <h3 class="title">블로그 체험단</h3>
                  <p class="desc">블로그마케팅은 가장 보편적인 마케팅 기법 중에
                    하나로 최근에는 맛집부터 기업까지 다양한 분야에서 효과를 보고 있습니다. 포털사이트 검색으로
                    원하는 정보를 얻고자 하는 소비자에게 접근성이
                    좋은 광고 효과는 물론이고, 긍정적인 이미지 실현이 가능하며 빠르고 확실한 광고로 바이럴마케팅을
                    처음 시작하시는 분들도 효과를 보실 수 있습니다.</p>
                  </span>
            </li>
          </ul>
        </div>
      </section>
      <section class="sec04">
        <div class="inner small">
          <h4 class="section-sub-title">효과적인 인플루언서 마케팅</h4>
          <div class="flexbox center">
            <img src="../resource/images/service_experience-marketing01.png" alt=""/>
            <img src="../resource/images/service_experience-marketing02.png" alt=""/>

          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>

export default {
  name: 'page-experience',
  components: {

  },

  mounted() {
    if (document.body.clientWidth < 800) {
      this.curWidth = 1
    }
    document.body.classList.add('sub');
    this.scroll();
  },

  data () {
    return {
      curWidth: 2.5
    }
  },

  methods: {
    scroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || window.screenY;
      document.querySelectorAll("section").forEach(item => {
        if(scrollTop > item.offsetTop - window.innerHeight / this.curWidth){
          item.classList.add("on");
        }
      });
      window.requestAnimationFrame(this.scroll);
    }
  }
}

</script>